import React from 'react';
import { withStyles } from "@mui/styles";
import {
  Checkbox,
  TableCell,
  TableHead,
  TableRow,
} from '@mui/material';

import ColumnHeader from "./ColumnHeader";

const styles = {
  root:{
    backgroundColor: '#f8f8f8'
  }
};

function TableSortHeader(props) {
  const {
    columns, controller, selectAllState, visibleColumns,
    handleOrderChange, onSelectAllClick, mindfileUserLevel,
    classes
  } = props;

  const cols = columns.filter(column => column.enabled && visibleColumns[column.key]);

  return (
    <TableHead id="columnsHeader" className={classes.root}>
      <TableRow>
        {cols.map((column) =>
            column.key === 'selected' ? (
              mindfileUserLevel <= 2 ? (
                <TableCell id="dataHeaderSelect" key={column.key} style={{ width: '42px', maxWidth: '42px', boxSizing: 'border-box',  padding: '0px',}}>
                  <Checkbox
                    indeterminate={selectAllState === 0}
                    checked={selectAllState === 1}
                    onChange={onSelectAllClick}
                  />
                </TableCell>
              )
              : null
            )
            : <ColumnHeader
                key={column.key}
                column={column}
                header={column.header}
                controller={controller}
                handleOrderChange={handleOrderChange}
              />
        )}
      </TableRow>
    </TableHead>
  )
}

export default withStyles(styles)(TableSortHeader);
